// extracted by mini-css-extract-plugin
export default {"radioBox":"index_radioBox__8Csb7","svgIcon":"index_svgIcon__7CmdO"};